import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { useStoreBoot } from '@/api/useStoreBoot';
import { ELoginMethods, ESessionStorageKeys } from '@/lib/enums';
import { BootData } from '@/lib/types';
import { useAppState } from '@/state/hooks/app.state.hook';
import { useLoginState } from '@/state/hooks/login.state.hook';
import { useUrlHash } from '@/state/hooks/useUrlHash';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { LoginButton } from '@/components/portal-ui';

import { useTranslations } from 'next-intl';

export const FacebookLoginButton = () => {
  const t = useTranslations();
  const router = useRouter();

  const { setDisplayLoader } = useAppState();
  const { getBoot } = useStoreBoot();
  const { loginResponse, shouldDisableLoginButtons, loginButtonClickWrapper } = useLoginState();
  const bootData = getBoot.data as BootData;

  const fbAppId = bootData?.integration?.playersAuthentication?.fbAppId;

  const facebookAccessToken = useUrlHash('#access_token');

  useEffect(() => {
    if (facebookAccessToken) facebookResponseHandler();
  }, [facebookAccessToken]);

  const facebookResponseHandler = () => {
    setDisplayLoader(true);
    const data = {
      userToken: facebookAccessToken || undefined,
      authMethod: ELoginMethods.FACEBOOK,
    };
    webStorageUtil.remove(ESessionStorageKeys.REDIRECT_STATE);
    loginResponse(data);

    // Clear the hash to allow subsequent logins to trigger the effect
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  };

  const loginClickHandler = () => {
    router.replace(
      `https://www.facebook.com/v17.0/dialog/oauth?response_type=token&client_id=${fbAppId}&redirect_uri=${window.location.origin}/login${window.location.pathname}&state=facebookredirect`
    );
  };

  return (
    <LoginButton
      variant="facebook"
      callback={() => loginButtonClickWrapper(loginClickHandler, ELoginMethods.FACEBOOK)}
      text={t('portal.login.signInWithFacebook')}
      dataTestId="facebook-login-button"
      isDisabled={shouldDisableLoginButtons}
      isModalMode={true}
      opacityOnDisabled={false}
    >
      <img src="https://media.appcharge.com/defaults/facebook_icon_white.svg" alt="facebook icon" />
    </LoginButton>
  );
};
